import { render, staticRenderFns } from "./ChecklistExtra.vue?vue&type=template&id=b9803f24&lang=pug&"
import script from "./ChecklistExtra.vue?vue&type=script&lang=js&"
export * from "./ChecklistExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports